import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from '../firebase/config';
import { showToast } from '../utils/toast'; // Importando a função do utilitário

function ProfilePage({ user, mspData }) {
    const [companyName, setCompanyName] = useState(mspData.companyName || '');
    const [isUploading, setIsUploading] = useState(false);
    
    // Função para atualizar os dados do perfil (nome da empresa)
    const handleProfileUpdate = async (e) => {
        e.preventDefault();
        const userDocRef = doc(db, 'msp_users', user.uid);
        try {
            await updateDoc(userDocRef, { companyName });
            showToast('success', 'Perfil atualizado com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar perfil:", error);
            showToast('error', 'Ocorreu um erro ao salvar as alterações.');
        }
    };

    // Função para carregar uma nova foto de perfil
    const handlePhotoUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setIsUploading(true);
        // Define o caminho no Firebase Storage onde a imagem será guardada
        const storageRef = ref(storage, `profile_pictures/${user.uid}/${file.name}`);
        
        try {
            // Carrega o ficheiro
            const snapshot = await uploadBytes(storageRef, file);
            // Obtém a URL pública do ficheiro carregado
            const photoURL = await getDownloadURL(snapshot.ref);
            
            // Atualiza o documento do utilizador com a nova URL da foto
            const userDocRef = doc(db, 'msp_users', user.uid);
            await updateDoc(userDocRef, { photoURL });

            showToast('success', 'Foto de perfil atualizada!');
        } catch (error) {
            console.error("Erro ao carregar a foto:", error);
            showToast('error', 'Falha ao carregar a foto.');
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <>
            <h1 className="h3 mb-3">Meu Perfil</h1>
            <div className="card shadow-sm">
                <div className="card-body">
                    <form onSubmit={handleProfileUpdate}>
                        <div className="row">
                            <div className="col-md-4 text-center">
                                <img 
                                    src={mspData.photoURL || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.email)}&background=0D6EFD&color=fff&size=150`} 
                                    alt="Foto de Perfil" 
                                    className="img-thumbnail mb-3"
                                    style={{width: '150px', height: '150px', objectFit: 'cover'}}
                                />
                                <input type="file" className="form-control form-control-sm" onChange={handlePhotoUpload} accept="image/*" disabled={isUploading} />
                                {isUploading && <div className="progress mt-2"><div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{width: '100%'}}></div></div>}
                            </div>
                            <div className="col-md-8">
                                <div className="mb-3">
                                    <label htmlFor="companyName" className="form-label">Nome da Empresa</label>
                                    <input type="text" id="companyName" className="form-control" value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">Email</label>
                                    <input type="email" id="email" className="form-control" value={user.email} disabled />
                                </div>
                                <button type="submit" className="btn btn-primary">Salvar Alterações</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default ProfilePage;